import React from 'react';
import { func, object } from 'prop-types';
import Waypoint from 'react-waypoint';
import { d_mt_promotion } from '@fiverr-private/icons';
import { Icon } from '@fiverr-private/fit';
import { I18n } from '@fiverr-private/i18n-react';
import WithImpressions from '../../shared/withImpressions';

import './style.scss';

const CLASS_NAME = 'contact-seller-mt-promotion-label';

const ContactSellerMTPromotion = ({ collectImpressions, impressionRef }) => (
    <div ref={impressionRef}>
        <Waypoint onEnter={collectImpressions}/>
        <div className={`${CLASS_NAME} p-t-12 flex`}>
            <Icon size={36} className="mt-icon">{d_mt_promotion}</Icon>
            <div className="m-l-16 t-a-left tbody-6 co-text-darker">
                <p className="text-semi-bold">
                    <I18n k="gig_page_perseus.contact_seller_options.mt_promotion_title"/>
                </p>
                <p>
                    <I18n k="gig_page_perseus.contact_seller_options.mt_promotion_body"/>
                </p>
            </div>
        </div>
    </div>
);

ContactSellerMTPromotion.propTypes = {
    collectImpressions: func,
    impressionRef: object
};

const impressionConfig = {
    DOMSelector: `.${CLASS_NAME}`,
    eventKey: 'localization_machine_translation_promotion_component_is_shown'
};

export { ContactSellerMTPromotion };
export default WithImpressions(ContactSellerMTPromotion, impressionConfig);
